import type { School } from '@awo-care/shared-core';

export interface SchoolCityGroup {
  city: string;
  schools: School[];
}

/**
 * Groups schools by city (`address.city`), cities sorted alphabetically (de
 * locale), schools within a city sorted alphabetically by `schoolName`.
 */
export function groupSchoolsByCity(schools: School[]): SchoolCityGroup[] {
  const byCity = new Map<string, School[]>();
  for (const school of schools) {
    const city = school.address?.city ?? '';
    const list = byCity.get(city) ?? [];
    list.push(school);
    byCity.set(city, list);
  }
  return [...byCity.entries()]
    .sort(([a], [b]) => a.localeCompare(b, 'de'))
    .map(([city, list]) => ({
      city,
      schools: [...list].sort((a, b) =>
        (a.schoolName ?? '').localeCompare(b.schoolName ?? '', 'de')
      ),
    }));
}
